import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { api } from "../../lib/api";
import { ConfirmDialog } from "../common/ConfirmDialog";
import { EstoqueToolModal } from "../agent/ConfigEstoque";

// Templates da Tool de Estoque: linhas kind="estoque" em /tool-templates.
// Pré-preenchem a criação de tools de estoque na workstation (a loja é por agente).
// Só são importáveis na seção Estoque — ficam fora do picker geral de modelos.
export function EstoqueTemplateTab() {
  const qc = useQueryClient();
  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState<any | null>(null);
  const [del, setDel] = useState<any | null>(null);

  const { data: templates = [], isLoading } = useQuery<any[]>({
    queryKey: ["tool-templates"],
    queryFn: () => api.get("/tool-templates"),
  });
  const estoqueTemplates = templates.filter((t: any) => t.kind === "estoque");

  const deleteMut = useMutation({
    mutationFn: (id: string) => api.delete(`/tool-templates/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tool-templates"] }),
  });

  if (isLoading) return <div style={{ color: "var(--ink-muted)", fontSize: 13 }}>Carregando…</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 720 }}>
      <span style={{ fontSize: 13, color: "var(--ink-secondary)", lineHeight: 1.6 }}>
        Templates da Tool de Estoque — pré-preenchem a criação de tools de estoque na
        workstation dos agentes. A loja é sempre configurada por agente; aqui ficam os
        textos e defaults.
      </span>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 13, color: "var(--ink-secondary)" }}>
          {estoqueTemplates.length} template{estoqueTemplates.length !== 1 ? "s" : ""} de estoque
        </span>
        <button
          onClick={() => setCreating(true)}
          style={{ background: "var(--brand)", color: "#fff", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 13, cursor: "pointer" }}
        >
          + Novo template
        </button>
      </div>

      {estoqueTemplates.length === 0 ? (
        <div style={{ padding: 32, textAlign: "center", color: "var(--line-max)", fontSize: 13, border: "1px dashed var(--line)", borderRadius: 8 }}>
          Nenhum template de estoque cadastrado ainda.
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {estoqueTemplates.map((tpl: any) => (
            <div
              key={tpl.id}
              onClick={() => setEditing(tpl)}
              style={{ background: "var(--surface-hover)", border: "1px solid var(--line)", borderRadius: 8, padding: "12px 16px", cursor: "pointer", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 500, fontSize: 13, color: "var(--ink)" }}>{tpl.name}</div>
                {(tpl.template_description || tpl.description) && (
                  <div style={{ fontSize: 12, color: "var(--ink-muted)", marginTop: 4 }}>{tpl.template_description || tpl.description}</div>
                )}
                <div style={{ fontSize: 11, color: "var(--line-max)", marginTop: 6, fontFamily: "var(--font-mono)" }}>
                  Estoque
                </div>
              </div>
              <button
                title="Excluir template"
                disabled={deleteMut.isPending}
                onClick={(e) => { e.stopPropagation(); setDel(tpl); }}
                style={{ background: "none", border: "none", color: "var(--ink-muted)", fontSize: 15, cursor: "pointer", lineHeight: 1, padding: 4, flexShrink: 0 }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "var(--ink-muted)")}
              >
                🗑
              </button>
            </div>
          ))}
        </div>
      )}

      {creating && (
        <EstoqueToolModal templateMode onClose={() => setCreating(false)} />
      )}
      {editing && (
        <EstoqueToolModal key={editing.id} templateMode tool={editing} onClose={() => setEditing(null)} />
      )}
      {del && (
        <ConfirmDialog
          title={`Excluir "${del.name}"?`}
          confirmLabel="Excluir"
          danger
          onConfirm={() => { deleteMut.mutate(del.id); setDel(null); }}
          onCancel={() => setDel(null)}
        />
      )}
    </div>
  );
}
